module.exports = __webpack_public_path__ + "static/media/icon-facebook.1624a32e.svg";